module.exports = __webpack_public_path__ + "static/renan-erno-80e081842a48951b4456ccb3d9808c4b.jpg";